import { toast } from "react-toastify";
import formErrorsHandler, { formErrorLoading } from "api/global/form-errors-handler";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    serviceTypesGet,
    serviceTypesGetById,
    serviceTypeCreate,
    serviceTypeUpdate,
    serviceTypeDelete
} from "api/menu/master-files/service-types/requests";

export const FETCH_SERVICE_TYPES_SUCCESS = "FETCH_SERVICE_TYPES_SUCCESS";
export const FETCH_SERVICE_TYPES_BY_ID_SUCCESS = "FETCH_SERVICE_TYPES_BY_ID_SUCCESS";

export const SERVICE_TYPES_REQUEST_LOADING = "SERVICE_TYPES_REQUEST_LOADING";
export const SERVICE_TYPES_REQUEST_ERRORS = "SERVICE_TYPES_REQUEST_ERRORS";

export const setLoading = () => ({
    type: SERVICE_TYPES_REQUEST_LOADING
});

export const fetchServiceTypes = (includeInActives = true) => dispatch => {
    dispatch(setLoading());
    serviceTypesGet(includeInActives)
        .then(response => {
            dispatch({
                type: FETCH_SERVICE_TYPES_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, SERVICE_TYPES_REQUEST_ERRORS));
        });
};

export const fetchServiceTypeById = (id) => dispatch => {
    serviceTypesGetById(id)
        .then(response => {
            dispatch({
                type: FETCH_SERVICE_TYPES_BY_ID_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, SERVICE_TYPES_REQUEST_ERRORS));
        });
};

export const insertServiceType = (data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    serviceTypeCreate(data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Successfully added new Service type "${data.code}"`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(formErrorLoading(false));
            dispatch(defaultErrorHandler(error, SERVICE_TYPES_REQUEST_ERRORS));
        });
};

export const updateServiceType = (id, data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    serviceTypeUpdate(id, data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Service type "${data.code}" has been updated`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const deleteServiceType = (id, code, callback = false) => dispatch => {
    dispatch(setLoading());
    serviceTypeDelete(id)
        .then(() => {
            toast(`Service type ${code} has been deleted`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, SERVICE_TYPES_REQUEST_ERRORS));
        });
};

export const clearServiceTypes = () => dispatch => {
    dispatch({
        type: FETCH_SERVICE_TYPES_SUCCESS,
        payload: []
    });
};

export const clearSingleServiceType = () => dispatch => {
    dispatch({
        type: FETCH_SERVICE_TYPES_BY_ID_SUCCESS,
        payload: []
    });
};
